module.exports = __webpack_public_path__ + "media/images/top/img_interview_miya-7026170d903d380d6cde20be679e1f95.jpg";